import React from 'react';
import { localizationService } from 'src/services';
import { useReduxSelector } from 'src/redux';
import { FeatureNames } from '@rcp/types';
import { Translate } from 'src/components/widgets/translate/translator';

interface OwnProps {}
type FeedbackFormProps = OwnProps;

export const HeaderFeedbackForm: React.SFC<FeedbackFormProps> = props => {
	const showFeedBackForm = useReduxSelector(
		state => state.featureSettings.featureFlagSettings[FeatureNames.FeedBackForm]
	);

	if (!showFeedBackForm) {
		return <></>;
	}

	return (
		<div>
			<a target="_blank" rel="noopener noreferrer" href="https://forms.office.com/r/PeUkex4DfF">
				<img id="feedback-img" src="img/icons/feedback.svg" alt="" />
				<br />
				<span className="header-title">
					<Translate>{localizationService.getLocalizedString('screen.labels.feedback')}</Translate>
				</span>
			</a>
		</div>
	);
};
